import { Component, Inject } from '@angular/core';
import { FORM_DIRECTIVES, ControlGroup, Control, Validators as AngularValidators } from '@angular/common';
import { RouteParams } from '@angular/router-deprecated';
import { TemplateService, LoadingService } from '../services';
import { Validators } from '../common/Validators';

@Component({
    selector: 'templatemgt',
    template: require('./templatemgt.html'),
    directives: [],
    providers: [TemplateService]
})
export class TemplateMgtComponent {
    counts: any;
    showCounts: boolean;

    constructor(
        protected templateService: TemplateService,
        protected loadingService: LoadingService
    ) {
        this.showCounts = false;
        this.counts = {
            "outcomeCounts": {
                "countFieldAddition": 0,
                "countFieldRemoved": 0,
                "countToSystem": 0,
                "countFromSystem": 0
            },
            "assessmentCounts": {
                "countFieldAddition": 0,
                "countFieldRemoved": 0,
                "countToSystem": 0,
                "countFromSystem": 0
            },
            "resultCounts": {
                "countFieldAddition": 0,
                "countFieldRemoved": 0,
                "countToSystem": 0,
                "countFromSystem": 0
            }
        };
    }

    doSync() {
        this.loadingService.startLoad();

        this.templateService.syncWithDefault().subscribe(
            counters => {
                this.showCounts = true;
                this.counts = counters;
            },
            null,
            () => this.loadingService.stopLoad()
        );
    }
}


/** WEBPACK FOOTER **
 ** ./app/templatemgt/TemplateMgtComponent.ts
 **/